@use "../../../../../../../styles/Constants.scss" as Constants;

.workTypeInput {
	margin-top: Constants.$val-spacing-l;
}
